import './ConstructionPage.scss'
import svg1 from '../../assets/icons/construction-machinery/construction-machinery (1).svg'
import svg2 from '../../assets/icons/construction-machinery/construction-machinery (2).svg'
import svg3 from '../../assets/icons/construction-machinery/construction-machinery (3).svg'
import svg4 from '../../assets/icons/construction-machinery/construction-machinery (4).svg'
import svg5 from '../../assets/icons/construction-machinery/construction-machinery (5).svg'
import svg6 from '../../assets/icons/construction-machinery/construction-machinery (6).svg'
import svg7 from '../../assets/icons/construction-machinery/construction-machinery (7).svg'
import svg8 from '../../assets/icons/construction-machinery/construction-machinery (8).svg'
import svg9 from '../../assets/icons/construction-machinery/construction-machinery (9).svg'
import svg10 from '../../assets/icons/construction-machinery/construction-machinery (10).svg'
import svg11 from '../../assets/icons/construction-machinery/construction-machinery (11).svg'
import svg12 from '../../assets/icons/construction-machinery/construction-machinery (12).svg'
import svg13 from '../../assets/icons/construction-machinery/construction-machinery (13).svg'
import svg14 from '../../assets/icons/construction-machinery/construction-machinery (14).svg'
import svg15 from '../../assets/icons/construction-machinery/construction-machinery (15).svg'
import svg16 from '../../assets/icons/construction-machinery/construction-machinery (16).svg'
import svg17 from '../../assets/icons/construction-machinery/construction-machinery (17).svg'
import svg18 from '../../assets/icons/construction-machinery/construction-machinery (18).svg'
import svg19 from '../../assets/icons/construction-machinery/construction-machinery (19).svg'
import svg20 from '../../assets/icons/construction-machinery/construction-machinery (20).svg'
import svg21 from '../../assets/icons/construction-machinery/construction-machinery (21).svg'
import svg22 from '../../assets/icons/construction-machinery/construction-machinery (22).svg'
import svg23 from '../../assets/icons/construction-machinery/construction-machinery (23).svg'
import svg24 from '../../assets/icons/construction-machinery/construction-machinery (24).svg'
import svg25 from '../../assets/icons/construction-machinery/construction-machinery (25).svg'
import svg26 from '../../assets/icons/construction-machinery/construction-machinery (26).svg'
import svg27 from '../../assets/icons/construction-machinery/construction-machinery (27).svg'
import svg28 from '../../assets/icons/construction-machinery/construction-machinery (28).svg'
import svg29 from '../../assets/icons/construction-machinery/construction-machinery (29).svg'
import svg30 from '../../assets/icons/construction-machinery/construction-machinery (30).svg'
import svg31 from '../../assets/icons/construction-machinery/construction-machinery (31).svg'
import svg32 from '../../assets/icons/construction-machinery/construction-machinery (32).svg'
import svg33 from '../../assets/icons/construction-machinery/construction-machinery (33).svg'
import svg34 from '../../assets/icons/construction-machinery/construction-machinery (34).svg'
import svg35 from '../../assets/icons/construction-machinery/construction-machinery (35).svg'
import svg36 from '../../assets/icons/construction-machinery/construction-machinery (36).svg'
import svg37 from '../../assets/icons/construction-machinery/construction-machinery (37).svg'
import svg38 from '../../assets/icons/construction-machinery/construction-machinery (38).svg'
import svg39 from '../../assets/icons/construction-machinery/construction-machinery (39).svg'
import svg40 from '../../assets/icons/construction-machinery/construction-machinery (40).svg'
import svg41 from '../../assets/icons/construction-machinery/construction-machinery (41).svg'
import svg42 from '../../assets/icons/construction-machinery/construction-machinery (42).svg'
import svg43 from '../../assets/icons/construction-machinery/construction-machinery (43).svg'
import svg44 from '../../assets/icons/construction-machinery/construction-machinery (44).svg'
import svg45 from '../../assets/icons/construction-machinery/construction-machinery (45).svg'
import svg46 from '../../assets/icons/construction-machinery/construction-machinery (46).svg'
import svg47 from '../../assets/icons/construction-machinery/construction-machinery (47).svg'

import React, { useState, useEffect } from 'react';

const svgs = [svg1,svg2,svg3,svg4,svg5,svg6,svg7,svg8,svg9,svg10,svg11,svg12,svg13,svg14,svg15,svg16,svg17,svg18,svg19,svg20,svg21,svg22,svg23,svg24,svg25,svg26,svg27,svg28,svg29,svg30,svg31,svg32,svg33,svg34,svg35,svg36,svg37,svg38,svg39,svg40,svg41,svg42,svg43,svg44,svg45,svg46,svg47]

function ConstructionPage() {

  const [selectedFile, setSelectedFile] = useState(null);

  useEffect(() => {
    let randomImageNumber = Math.floor(Math.random() * 47)
    setSelectedFile(svgs[randomImageNumber])
  },[])

  if(!selectedFile) {
    return (
      <div className='construction'> 
        <div className='construction__container'>
          <h1 className='construction__header'>... Loading ...</h1>
        </div>
      </div>
    )
  }

  return (
    <div className='construction'> 
      <img className='construction__svg' src={selectedFile} alt='construction background'/>
      <div className='construction__container'>
        <h1 className='construction__header'>Page is currently under construction</h1>
        <h2 className='construction__description'>Building away!</h2>
      </div>
    </div>
  )
}

export default ConstructionPage